import LottieAnimation from "../animations";
import * as animationData from "../../../json/loader.json";

const typedAnimationData: JSON = animationData as unknown as JSON;
const SignUpAnimation = () => {
  return (
    <div className="h-screen w-screen fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-97 z-20">
      <div className="z-30 w-80">
        <LottieAnimation
          type="json"
          jsonData={typedAnimationData}
          height="250px"
          width="250px"
        />
      </div>
    </div>
  );
};

export default SignUpAnimation;
